(function () {
  const context = window.pmAnalyticsContext || {};

  const clean = (value, maxLength = 120) => {
    if (value === null || value === undefined) return undefined;
    const text = String(value).replace(/\s+/g, ' ').trim();
    return text ? text.slice(0, maxLength) : undefined;
  };

  const track = (eventName, parameters = {}) => {
    if (!eventName) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...context,
      ...Object.fromEntries(
        Object.entries(parameters).filter(([, value]) => value !== undefined && value !== null && value !== '')
      ),
    });
  };

  const getSearchTerm = () => new URLSearchParams(window.location.search).get('q') || '';
  const getLabel = (element) =>
    clean(
      element?.closest('label')?.innerText ||
        element?.closest('[data-facet]')?.querySelector('label')?.innerText ||
        element?.getAttribute('aria-label') ||
        element?.value
    );

  window.pmAnalytics = window.pmAnalytics || {};
  window.pmAnalytics.track = track;

  if (context.page_type === 'collection') {
    track('collection_view', {
      collection_handle: context.collection_handle,
      collection_title: context.collection_title,
      collection_product_count: context.collection_product_count,
    });
  }

  if (context.page_type === 'search' || window.location.pathname === '/search') {
    track('search_results_view', {
      search_term: clean(getSearchTerm()),
      search_results_count: context.search_results_count,
    });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/search')) return;
    track('search_submit', { search_term: clean(form.querySelector('input[name="q"]')?.value) });
  });

  document.addEventListener('change', (event) => {
    const control = event.target;
    if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;
    const name = clean(control.name);
    if (!name?.startsWith('filter.')) return;

    track('filter_used', {
      filter_name: name.replace(/^filter\./, ''),
      filter_value: clean(control.value),
      filter_label: getLabel(control),
      filter_state: control.checked === false ? 'removed' : 'selected',
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('[data-sample-trigger]')) {
      track('order_sample_click', { product_id: context.product_id, product_title: context.product_title });
    }

    const sampleOption = target.closest('[data-sample-option]');
    if (sampleOption) {
      track('order_sample_option_click', {
        product_id: context.product_id,
        sample_variant_id: clean(sampleOption.dataset.variantId),
        sample_option: clean(sampleOption.dataset.optionLabel),
      });
    }

    const productLink = target.closest('a[href*="/products/"]');
    const productCard = productLink?.closest('.card-wrapper, .product-card-wrapper');
    if (productLink && productCard) {
      track('select_item', {
        item_name: clean(productLink.innerText || productLink.getAttribute('aria-label')),
        item_url: productLink.href,
        item_list_name: context.collection_title || context.page_type,
      });
    }
  });

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      const label = clean(details.querySelector(':scope > summary')?.innerText);
      const isQuickOrder = details.classList.contains('quick-order-toggle');
      const isDelivery = /deliver|shipping|returns?/i.test(label || '');

      if (isQuickOrder) {
        track('quick_order_open', {
          product_id: context.product_id,
          product_title: context.product_title,
          quick_order_label: label,
        });
      } else if (isDelivery) {
        track('delivery_information_view', {
          product_id: context.product_id,
          product_title: context.product_title,
          information_label: label,
        });
      } else if (label) {
        track('accordion_open', { accordion_label: label });
      }
    },
    true
  );

  document.addEventListener('quick-order-mode-change', (event) => {
    track('quick_order_mode_change', {
      product_id: context.product_id,
      quick_order_mode: event.detail?.mode,
      quick_order_quantity: event.detail?.quantity,
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('quick-order-list')) return;
    const list = form.closest('quick-order-list');
    track('quick_order_add_to_cart_attempt', {
      product_id: list?.dataset.productId || context.product_id,
      quick_order_variant_count: list?.querySelectorAll('input[type="number"]').length,
      quick_order_quantity: [...(list?.querySelectorAll('input[type="number"]') || [])].reduce(
        (total, input) => total + (Number(input.value) || 0),
        0
      ),
    });
  });
})();
